import { DOCUMENT } from '@angular/common';
import { inject, Injectable } from '@angular/core';
import { ColorPalette, ColorUtils, SalonDesignModel } from '@concretecode/shared';

@Injectable({ providedIn: 'root' })
export class CustomThemeService {
  private readonly document = inject(DOCUMENT);

  setRootColorPalette(salonDesign: SalonDesignModel): void {
    const root = this.document.documentElement;
    this.#applyPalette(root, '--app', ColorUtils.createPrimaryPalette(salonDesign.colorLightModePrimary));
    this.#applyPalette(root, '--app-dark', ColorUtils.createPrimaryPalette(salonDesign.colorDarkModePrimary));
  }

  #applyPalette(root: HTMLElement, prefix: string, palette: ColorPalette): void {
    root.style.setProperty(`${prefix}-primary`, palette.primary);
    root.style.setProperty(`${prefix}-primary-hover`, palette.hover);
    root.style.setProperty(`${prefix}-primary-active`, palette.active);
    root.style.setProperty(`${prefix}-primary-pale`, palette.pale);
    root.style.setProperty(`${prefix}-primary-subtle`, palette.subtle);
    root.style.setProperty(`${prefix}-primary-fg`, palette.foreground);
  }
}
